module.exports = __webpack_public_path__ + "static/media/flask.dc0f58be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/menu/flask.svg
// module id = 57
// module chunks = 0